import Avatar from "../ui/avatar/Avatar";
import { findCountryByValue } from '../../lib/countries/countries.utils'

import type { User } from "../../types/userTypes";

type Props = {
  user: User
}

const UserMetaCard = ({ user }: Props) => {
  const country = findCountryByValue(user.countryCode)
  return (
    <div className="p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6">
      <div className="flex flex-col gap-5 xl:flex-row xl:items-center xl:justify-between">
        <div className="flex flex-col items-center w-full gap-6 xl:flex-row">
          <div className="overflow-hidden">
            <Avatar src={user.img?.small} size="xxxlarge" />
          </div>
          <div className="order-3 xl:order-2">
            <h4 className="mb-2 text-lg font-semibold text-center text-gray-800 dark:text-white/90 xl:text-left">
              {user.firstName} {user.lastName}
            </h4>
            <div className="flex flex-col items-center gap-1 text-center xl:flex-row xl:gap-3 xl:text-left">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                {country?.title}
              </p>
              <div className="hidden h-4.5 w-px bg-gray-300 dark:bg-gray-700 xl:block"></div>
                <img
                  alt={country?.value}
                  src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${country?.value?.toUpperCase()}.svg`}
                  className="inline mr-2 h-6 rounded-sm"
                />                
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserMetaCard;
